import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import gaugeGif from '../../../../assets/gifs/unit-treshold-yellow.gif';
import styles from './UnitRunningLowModal.module.scss';
import { ApplicationRoutes } from '../../../../routes';

interface Props {
  unitsRemaining?: number;
  onClose: () => void;
}

export const UnitRunningLowModal: React.FC<Props> = ({ unitsRemaining, onClose }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleTopUpNow = () => {
    onClose();
    navigate(`/${ApplicationRoutes.BUY_ELECTRICITY}`);
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.container} onClick={e => e.stopPropagation()}>
        <div className={styles.modal}>
          <img src={gaugeGif} alt={t('home.web.unitGauge')} width="133" height="133" />
          <h2 className={styles.title}>{t('energyManagement.unitRunningLow')}</h2>
          <p className={styles.description}>{t('energyManagement.unitRunningLowSubtitle')}</p>
          <div className={styles.unitRow}>
            <span className={styles.unitLabel}>{t('energyManagement.unitRemaining')}</span>
            <span className={styles.unitBadge}>
              {unitsRemaining != null ? unitsRemaining.toFixed(1) : '—'}
            </span>
          </div>
          <div className={styles.buttons}>
            <button className={styles.remindButton} onClick={onClose}>
              {t('energyManagement.remindMeLater')}
            </button>
            <button className={styles.topUpButton} onClick={handleTopUpNow}>
              {t('energyManagement.topUpNow')}
            </button>
          </div>
        </div>
        <button className={styles.closeButton} onClick={onClose} aria-label={t('home.web.close')}>
          ✕
        </button>
      </div>
    </div>
  );
};
